import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DemoUiService } from '../../core/demo-ui.service';
import { SECTION_COMPONENTS } from '../../shared/compound/section.components';
@Component({ selector: 'rv-reports', standalone: true, imports: [...SECTION_COMPONENTS], templateUrl: './reports.component.html', changeDetection: ChangeDetectionStrategy.OnPush })
export class ReportsComponent { readonly ui = inject(DemoUiService);
 readonly grid = [0,20,40,60,80].map(value => ({value,y:250-value*2.8}));
 readonly days = ['Lun','Mar','Mié','Jue','Vie','Sáb','Dom'].map((name,i) => ({name,residents:[62,58,64,60,66,71,55][i],visitors:[14,18,12,16,22,31,27][i]}));
 print(): void { window.print(); }
 }
